module.exports = __webpack_public_path__ + "static/img/h-i-8.8da24148.png";